import React from "react";
import CookieBanner from "./CookieBanner";
import CookiePreferencesModal from "./CookiePreferencesModal";
import { useCookieConsentContext } from "../../context/CookieConsentContext";

/**
 * CookieConsentSystem
 * Drop this anywhere inside <CookieConsentProvider>.
 * It reads state from context and renders the appropriate UI.
 */
export default function CookieConsentSystem() {
  const {
    preferences,
    showBanner,
    showModal,
    acceptAll,
    rejectAll,
    savePreferences,
    openModal,
    closeModal,
  } = useCookieConsentContext();

  return (
    <>
      {/* Banner — shown on first visit */}
      {showBanner && (
        <CookieBanner
          onAcceptAll={acceptAll}
          onRejectAll={rejectAll}
          onManage={openModal}
        />
      )}

      {/* Preferences Modal */}
      {showModal && (
        <CookiePreferencesModal
          currentPreferences={preferences}
          onSave={savePreferences}
          onAcceptAll={acceptAll}
          onClose={closeModal}
        />
      )}

    </>
  );
}
